const FIREBASE_AUTH_ERROR = {
  "auth/user-not-found":
    "Tài khoản không tồn tại. Vui lòng kiểm tra lại email.",
  "auth/wrong-password": "Mật khẩu không đúng. Vui lòng thử lại.",
  "auth/invalid-email": "Địa chỉ email không hợp lệ.",
  "auth/user-disabled": "Tài khoản này đã bị vô hiệu hóa.",
  "auth/email-already-in-use":
    "Email này đã được sử dụng bởi một tài khoản khác.",
  "auth/weak-password":
    "Mật khẩu quá yếu. Vui lòng chọn mật khẩu khác mạnh hơn.",
  "auth/too-many-requests":
    "Bạn đã thực hiện quá nhiều yêu cầu. Vui lòng thử lại sau.",
  "auth/network-request-failed":
    "Lỗi mạng. Vui lòng kiểm tra kết nối internet của bạn.",
  "auth/invalid-credential": "Thông tin đăng nhập không hợp lệ.",
};

export const getFirebaseAuthErrorMessage = (errorCode) => {
  return (
    FIREBASE_AUTH_ERROR[errorCode] || "Đã có lỗi xảy ra. Vui lòng thử lại."
  );
};
